import type { IconData } from '@stacksjs/iconify-core'

export const gbEng1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#ce1124\" d=\"M215 0h82v512h-82z\"/><path fill=\"#ce1124\" d=\"M0 215h512v82H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gbEng1x1
